<script>
import IntegrationsBase from "@/components/tools/IntegrationsBase.vue";
import Integrat from "@/components/tools/modals/member-area/Integrat.vue";
export default {
  extends: IntegrationsBase,
  data() {
    return {
      name: "Certificações MEC",
      subtitle: "Integre sua secretaria digital à " + this.$config.get("title"),
      newModal: true
    };
  },
  computed: {
    options() {
      return [
        {
          title: "Unifast",
          image: require("@/assets/images/integrations/unifast.svg"),
          description:
            "Integre sua secretaria digital à " + this.$config.get("title"),
          modal: Integrat,
          name: "integrat",
          link: "https://unifast.com.br/"
        },
        {
          title: "Usina",
          image: require("@/assets/images/integrations/usina-edu.png"),
          link: "https://suapropriapos.usinaedu.com/em-breve"
        }
      ];
    }
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("product/get", { limit: 1000 })
      .finally(() => (this.loading = false));
  }
};
</script>
